import { render, staticRenderFns } from "./documentViewer.vue?vue&type=template&id=2a0cd9a0&scoped=true&"
import script from "./documentViewer.vue?vue&type=script&lang=js&"
export * from "./documentViewer.vue?vue&type=script&lang=js&"
import style0 from "./documentViewer.vue?vue&type=style&index=0&id=2a0cd9a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0cd9a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
